/* eslint-disable */
import React from 'react'
import '../../css/table.css'
import { orderBy, map } from 'lodash'
import moment from 'moment'
import ReactTable from 'react-table'
import Card from 'components/Card/Card.jsx'
import { db } from '../../services/firebase'
import SweetAlert from 'react-bootstrap-sweetalert'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { Grid, Row, Col } from 'react-bootstrap'

export default class Orders extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            orders: [],
            loading: false,
            alert: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchOrders()
    }

    render() {
        const { orders, loading, alert } = this.state
        return (
            <div className='main-content'>
                {alert}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                {this._renderTable(this._prepareTableData(orders), loading)}
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    _prepareTableData = orders => {
        const data = []

        map(orders, order => {
            let newOrder = {
                id: order.id,
                orderNumber: Number(order.orderNumber),
                orderDate: moment(order.date).format('DD/MM/YYYY'),
                partner: order.partner.tradingName,
                price: `R$ ${this._handleTotalPrice(order.products)}`,
                status: this._handleStatus(order.status)
            }

            data.push(newOrder)
        })

        return data
    }

    _handleTotalPrice = products => {
        let output = new Number(0)

        map(products, product => {
            product.items && map(product.items, item => {
                let factory = Number(parseFloat(item.factoryPrice.replace(',', '.')).toFixed(2))
                output += factory
            })

            if (!product.items) {
                let factory = parseFloat(product.factoryPrice.replace(',', '.'))
                output += factory
            }
        })
        return parseFloat(output).toFixed(2).replace('.', ',')
    }

    _handleStatus = status => {
        switch (status) {
            case 'new':
                return 'Novo'
            case 'waiting':
                return 'Processando'
            case 'sent':
                return 'Enviado'
            case 'delivered':
                return 'Entregue'
            case 'cancelled':
                return 'Cancelado'
            default:
                return 'Processando'
        }
    }

    _renderTable = (data, loading) => (
        <ReactTable
            columns={[
                { Header: 'Data', accessor: 'orderDate' },
                { Header: 'Parceiro', accessor: 'partner' },
                { Header: 'Pedido', accessor: 'orderNumber' },
                { Header: 'Valor', accessor: 'price' },
                { Header: 'Status', accessor: 'status' }
            ]}
            data={orderBy(data, ['orderNumber'], ['desc'])}
            onFetchData={this._fetchOrders}
            loading={loading}
            defaultPageSize={10}
            className='-striped -highlight'
            previousText='Anterior'
            nextText='Próximo'
            loadingText='Carregando'
            noDataText='Nenhum pedido encontrado'
            pageText='Página'
            ofText='de'
            rowsText='Registros'
            sortable={false}
            getTdProps={(state, rowInfo, column, instance) => {
                return {
                    onClick: e => this.props.history.push(`/order/${rowInfo.original.id}`)
                }
            }}
        />
    )

    /**************** 
      Fetch data from Firestore
  *****************/

    _fetchOrders = () => {
        this.setState({ loading: true })
        db.collection('orders').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passOrdersToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    _passOrdersToState = snapshot => {
        const orders = []
        snapshot.forEach(order => orders.push({ ...order.data(), id: order.id }))
        return this.setState({ loading: false, orders })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

}



// WEBPACK FOOTER //
// ./src/views/Orders/Orders.jsx